import React, { Component } from "react";
import PropTypes from "prop-types";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import { blue500, greenA200 } from "material-ui/styles/colors";
import FormatIconLeft from "material-ui/svg-icons/editor/format-align-left";
import FormatIconCenter from "material-ui/svg-icons/editor/format-align-center";
import FormatIconRight from "material-ui/svg-icons/editor/format-align-right";

class Alignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
    this.onChange = this.onChange.bind(this);
  }
  onChange = (event, value) => {
    this.setState({ value: value });
    this.props.onChange(value);
  };
  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value: value });
    }
  }
  render() {
    const { title } = this.props;
    return (
      <div>
        <RadioButtonGroup
          name={title}
          valueSelected={this.state.value}
          onChange={this.onChange}
          style={styles.radioGroup}
        >
          <RadioButton
            value="flex-start"
            label=""
            checkedIcon={<FormatIconLeft style={{ color: blue500 }} />}
            uncheckedIcon={<FormatIconLeft style={{ color: greenA200 }} />}
            style={styles.radioButton}
          />
          <RadioButton
            value="center"
            label=""
            checkedIcon={<FormatIconCenter style={{ color: blue500 }} />}
            uncheckedIcon={<FormatIconCenter style={{ color: greenA200 }} />}
            style={styles.radioButton}
          />
          <RadioButton
            value="flex-end"
            label=""
            checkedIcon={<FormatIconRight style={{ color: blue500 }} />}
            uncheckedIcon={<FormatIconRight style={{ color: greenA200 }} />}
            style={styles.radioButton}
          />
        </RadioButtonGroup>
      </div>
    );
  }
}

const styles = {
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

Alignment.PropTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

Alignment.defaultProps = {
  title: "Alignment",
  value: "center"
};
export default Alignment;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/alignment/index.js